import axios from "axios";

export const GET_REGLA_NEGOCIO_LIST     = "GET_REGLA_NEGOCIO_LIST";
export const GET_REGLA_NEGOCIO_DETAIL   = "GET_REGLA_NEGOCIO_DETAIL";
export const PUT_REGLA_NEGOCIO_EDIT     = "PUT_REGLA_NEGOCIO_EDIT";
export const POST_REGLA_NEGOCIO_CREATE  = "POST_REGLA_NEGOCIO_CREATE";
export const DELETE_REGLA_NEGOCIO       = "DELETE_REGLA_NEGOCIO";
export const ACTIVAR_REGLA_NEGOCIO      = "ACTIVAR_REGLA_NEGOCIO";


export const getReglaNegocioList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/ReglaNegocio/ObtieneTodasLasReglaNegocio")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_REGLA_NEGOCIO_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_REGLA_NEGOCIO_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getReglaNegocioDetail = (id) => {

    return (dispatch) => {
        axios
            .get(
                "/api/ReglaNegocio/ObtieneReglaNegocioPorId?id=" +id
            )
            .then(function (response) {
                //console.log(response.data);

                dispatch({
                    type: GET_REGLA_NEGOCIO_DETAIL,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: GET_REGLA_NEGOCIO_DETAIL,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
}; //END DETAIL

export const putReglaNegocioUpdate = (data, id) => {

    return (dispatch) => {
        axios
            .put(
                "/api/ReglaNegocio/" + id,data
                )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: PUT_REGLA_NEGOCIO_EDIT,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_REGLA_NEGOCIO_EDIT,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE

export const postReglaNegocioCreate = (data) => {

    return (dispatch) => {
        axios
        .post(
            "/api/ReglaNegocio",data
        )
        .then(function (response) {
            //console.log(response);
        
            dispatch({
                type: POST_REGLA_NEGOCIO_CREATE,
                payload: {
                    data: response.data,
                    errorMessage: false,
                },
            });
        })
        .catch(function (error) {
            dispatch({
                type: POST_REGLA_NEGOCIO_CREATE,
                payload: {
                    data: false,
                    errorMessage: error.message,
                },
            });
        });
    };
  
};

export const deleteReglaNegocio = (data, id) => {

    return (dispatch) => {

        //console.log("ACTION deleteReglaNegocio");

        axios
            .put(
                "/api/ReglaNegocio/BorrarReglaNegocio/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: DELETE_REGLA_NEGOCIO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: DELETE_REGLA_NEGOCIO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
    
};

export const activarReglaNegocio = (data, id) => {

    return (dispatch) => {

        axios
            .put(
                "/api/ReglaNegocio/ActivarReglaNegocio/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: ACTIVAR_REGLA_NEGOCIO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: ACTIVAR_REGLA_NEGOCIO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

};